import React, { useEffect, useState } from "react";
import organizationActions from "../../../../redux/organizations/actions";
import { useDispatch, useSelector } from "react-redux";
import MenuConfigurationSearch from "../MenuConfigurationSearch";
import MenuConfigurationMenuItemsTable from "./MenuConfigurationMenuItemsTable";
import MenuConfigurationSearchExtraContent from "../MenuConfigurationSearchExtraContent";
import MenuConfigurationTabExtraContent from "../MenuConfigurationTabExtraContent";

const MenuConfigurationMenuItems = ({ restaurantId, setRestaurantId }) => {
  const dispatch = useDispatch();
  const { menuItems } = useSelector((state) => state.menuConfigurationReducer);
  const { getMenuConfiguration } = organizationActions;

  const [dataSource, setDataSource] = useState(menuItems);
  const [searchedTable, setSearchedTable] = useState(null);
  const [showDraggableButton, setShowDraggableButton] = useState(false);
  const [filterMenuItems, setFilterMenuItems] = useState(null);
  const [filterValue, setFilterValue] = useState("Всички");
  const [searchedFilterItems, setSearcheFilterItems] = useState(null);
  const [searchedValue, setSearchedValue] = useState(null);

  useEffect(() => {
    dispatch(getMenuConfiguration());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataSource(menuItems);

    if (searchedValue === null) {
      setSearchedTable(menuItems);
    } else {
      setSearchedTable(
        menuItems.filter((o) =>
          Object.keys(o).some((k) => {
            return String(o[k])
              .toLowerCase()
              .includes(searchedValue.toLowerCase());
          })
        )
      );
    }

    if (filterValue !== "Всички") {
      setFilterMenuItems(
        menuItems.filter((item) => item.menuCategoryName === filterValue)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuItems]);

  useEffect(() => {
    if (filterValue === "Всички") {
      setFilterMenuItems(null);
      setShowDraggableButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue]);

  return (
    <>
      <div className="menu-configuration-tab-extra-container-desktop-display-none">
        <MenuConfigurationTabExtraContent
          restaurantId={restaurantId}
          setRestaurantId={setRestaurantId}
        />
      </div>
      <div className="menu-configuration-menu-items-container">
        <MenuConfigurationSearch
          tabSelected="menu"
          filterMenuItems={filterMenuItems}
          menuDataSource={dataSource}
          setSearchedTable={setSearchedTable}
          setSearchedValue={setSearchedValue}
          setSearcheFilterItems={setSearcheFilterItems}
        />
        <MenuConfigurationSearchExtraContent
          menuDataSource={dataSource}
          setFilterMenuItems={setFilterMenuItems}
          setSearcheFilterItems={setSearcheFilterItems}
          setFilterValue={setFilterValue}
          filterValue={filterValue}
          setShowDraggableButton={setShowDraggableButton}
          showDraggableButton={showDraggableButton}
          restaurantId={restaurantId}
        />
      </div>
      <MenuConfigurationMenuItemsTable
        menuDataSource={dataSource}
        setMenuDataSource={setDataSource}
        searchedValue={searchedValue}
        setSearchedTable={setSearchedTable}
        filterValue={filterValue}
        setFilterMenuItems={setFilterMenuItems}
        setShowDraggableButton={setShowDraggableButton}
        filterMenuItems={filterMenuItems}
        searchedTable={searchedTable}
        searchedFilterItems={searchedFilterItems}
      />
    </>
  );
};

export default MenuConfigurationMenuItems;
